import Vue from "vue";
// import { ApmVuePlugin } from "@elastic/apm-rum-vue";
import { init as initApm } from "@elastic/apm-rum";
import VueAxios from "vue-axios";
import axios from "axios";
import { BootstrapVue, BootstrapVueIcons, IconsPlugin } from "bootstrap-vue";
// import VueSessionStorage from "vue-sessionstorage";
import VueClipboard from "vue-clipboard2";
// import { VueReCaptcha } from "vue-recaptcha-v3";
import App from "./App.vue";
import router from "./router";
import store from "./stores/store";
import Auth from "@/components/layouts/Auth";
import Guest from "@/components/layouts/Guest";
import Blank from "@/components/layouts/Blank";
import Event from "@/components/layouts/Event";
import NewLayout from "@/components/layouts/New-Layout";
import Guest2 from "@/components/layouts/Guest2";
import IdleVue from "idle-vue";
import VueMeta from "vue-meta";

import "vuetify/dist/vuetify.min.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./assets/css/animate.css";
import "./assets/css/font-awesome.min.css";
import "./assets/css/app.css";
import "@/plugins";

import VueSanitize from "vue-sanitize";

const eventsHub = new Vue();

const apm = initApm({
  // Set required service name (allowed characters: a-z, A-Z, 0-9, -, _, and space)
  serviceName: "dccom-prod-public-web",

  // Set custom APM Server URL (default: http://localhost:8200)
  serverUrl: "https://apmdevops.adira.one",

  // Set service version (required for sourcemap feature)
  environment: "production",
});

/* defaultOptions = {
  allowedTags: ['a', 'b'],
  allowedAttributes: {
    'a': ['href']
  }
}; */

Vue.use(VueSanitize);

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 300000, // 5 minute
  startAtIdle: false,
});

Vue.use(VueMeta);

// Vue.use(VueReCaptcha, {
//   siteKey: "6Les0OgUAAAAAPICfny1FkMKqq5DiBNucJ41AZWa",
//   loaderOptions: {
//     autoHideBadge: true,
//   },
// });


Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
// Vue.use(VueSessionStorage);

VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard);

Vue.component("auth-layout", Auth);
Vue.component("guest-layout", Guest);
Vue.component("blank-layout", Blank);
Vue.component("event-layout", Event);
Vue.component("new-layout", NewLayout);
Vue.component("guest2-layout", Guest2);

Vue.mixin({
  methods: {
    encode: (obj) => window.btoa(JSON.stringify(obj)),
    decode: (str) => JSON.parse(window.atob(str)),
  },
  // created() {
  // let user = JSON.parse(sessionStorage.getItem('user'))
  // Axios.defaults.baseURL = store.state.api_base_url;
  // Axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded';

  // if (user) {
  //   this.current_user = user
  //   Axios.defaults.headers.common['Authorization'] = user.api_token
  // } else {
  //   this.current_user.api_token = '-'
  // }
  // }
});
Vue.use(VueAxios, axios);

import VueGtm from "@gtm-support/vue2-gtm";
Vue.use(VueGtm, {
  id: "GTM-5FMDRK2",
  source: "https://www.googletagmanager.com/gtm.js",
  defer: false,
  compatibility: false,
  nonce: "2726c7f26c",
  enabled: true,
  debug: false,
  loadScript: true,
  vueRouter: router,
  trackOnNextTick: false,
});

import VueGtag from "vue-gtag";
Vue.use(
  VueGtag,
  {
    config: {
      id: "UA-100550032-1",
    },
  },
  router
);

Vue.prototype.$window = window;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
